import { useVATStore } from "../../stores/VATStore";
import VatForm from "../fragments/VatForm";

const StepVAT = () => {
  const { error, vatFormErrors } = useVATStore();

  return (
    <div className="simple-form">
      <h2 className='ncf-title'>VAT Relief Details</h2>
      <span className='ncf-subtitle'>Please provide the following information for the person who will use our alarm service.</span>
      <VatForm />
      {vatFormErrors?.includes('medical_conditions') ? <div className="error">You need to enter the medical conditions</div> : ''}
      {!vatFormErrors?.includes('medical_conditions') && error !== '' ? <div className="error">{error}</div> : ''}
    </div>
  );
};

export default StepVAT;